import React from 'react';
import {Title, Text, Wrapper} from './NotFound.style';

export const NotFound = () => (
  <Wrapper>
    <Title>404</Title>
    <Text>Sorry, page not found</Text>
  </Wrapper>
);
